import React from 'react'
import { Modal, message } from 'antd'
import { $t } from '~/i18n.js'
import { api } from '~/lib/api.js'
import { text_to_speech } from '~/lib/speech.js'
import { showBadgeNotificationModal } from '~/components/badges/BadgeAlertModal.jsx'

export const getBaseData = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'FLIGHTS_PENDING'
      })
      const data = await api.get('flights/base_data.json')
      data && dispatch({
        type: 'SET_BASE_DATA',
        vliegers: data.vliegers,
        default_vliegers: data.default_vliegers,
        kisten: data.kisten,
        bevoegdheden: data.bevoegdheden,
        group_name_lookup: data.group_name_lookup
      })
    } catch (error) {
      dispatch({
        type: 'FLIGHTS_ERROR'
      })
    }
  }
}

export const getFlights = ({ dag_id, skipPending = false, origin }) => async (dispatch) => {
  // console.log('getFlights called with dag_id:', dag_id, 'skipPending:', skipPending, 'origin:', origin)
  if (!skipPending) {
    dispatch({
      type: 'FLIGHTS_PENDING'
    })
  }

  const res = await api.get(`flights/${dag_id}/flights.json`)

  res && dispatch({
    type: 'FLIGHTS_SUCCESS',
    allFlights: res.allFlights?.length > 0 ? res.allFlights : []
  })

  res && dispatch({
    type: 'UPDATE_OGN_MODE',
    ogn_mode: res.ogn_mode,
    default_flight_cat: res.default_flight_cat,
    default_sleep_cat: res.default_sleep_cat,
    default_tmg_cat: res.default_tmg_cat
  })

  return res && res.allFlights
}

export const getFlightStats = ({ ...params }) => async (dispatch) => {
  dispatch({
    type: 'FLIGHT_STATS_PENDING'
  })

  const query_string = new URLSearchParams()
  Object.entries(params).map(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query_string.append(key, value)
    }
  })
  const res = await api.get('flightstats.json?' + query_string.toString())

  dispatch({
    type: 'FLIGHT_STATS_SUCCESS',
    flights: res && res.results.length > 0 ? res.results : [],
    count: res && res.count,
    total_starts: res && res.total_starts ? res.total_starts : 0,
    total_pic_starts: res && res.total_pic_starts ? res.total_pic_starts : 0,
    total_dbo_starts: res && res.total_dbo_starts ? res.total_dbo_starts : 0,
    total_time: res && res.total_time ? res.total_time : 0,
    total_dbo_time: res && res.total_dbo_time ? res.total_dbo_time : 0,
    total_pic_time: res && res.total_pic_time ? res.total_pic_time : 0
  })

  return res
}

const stripPrivacyFields = (data) => {
  const result = { ...data }
  if (result.gezagvoerder_naam === '-') {
    delete result.gezagvoerder_naam
    delete result.gezagvoerder_id
  }
  if (result.tweede_inzittende_naam === '-') {
    delete result.tweede_inzittende_naam
    delete result.tweede_inzittende_id
  }
  if (result.betalend_lid_id === -99) {
    delete result.betalend_lid_id
  }
  return result
}

export const newFlight = (data) => async (dispatch) => {
  dispatch({
    type: 'NEW_FLIGHT',
    flightData: data
  })
}

export const updateFlight = (data, saveToQueueWhenOffline) => async (dispatch) => {
  // sometimes you only want to update
  if (data.onlyUpdateRedux) {
    return dispatch({
      type: 'UPDATE_FLIGHT',
      flightData: data
    })
  }

  // if you are not online, save to queue and return
  if (saveToQueueWhenOffline && !window.navigator.onLine) {
    dispatch({
      type: 'ADD_TO_QUEUE',
      data
    })

    // if we must delete, do that, return null. The deletion request is put in queue
    if (data?.action === 'delete') {
      dispatch({
        type: 'DELETE_FLIGHT',
        flightData: data
      })
      return null
    }

    dispatch({
      type: 'UPDATE_FLIGHT',
      flightData: data
    })
    return data
  }

  // save flight to api if we are online
  const flightData = await api.post('flights/save_flight.json', stripPrivacyFields(data), !saveToQueueWhenOffline)

  // update data on correct return from server, or if you are allowed to save to queue
  if (flightData || saveToQueueWhenOffline) {
    if (data?.action === 'delete' || flightData?.action == 'delete') {
      dispatch({
        type: 'DELETE_FLIGHT',
        flightData: data
      })
      return null
    }

    // after save always save to active Flight, overwriting flightData fields from server prio 1
    dispatch({
      type: 'UPDATE_FLIGHT',
      flightData: { ...data, ...flightData }
    })
  }

  // if no result, then error is created and we save to queue
  if (saveToQueueWhenOffline && !flightData) {
    dispatch({
      type: 'ADD_TO_QUEUE',
      uuid: data.uuid,
      data
    })
  }

  // add base kist to data if required and returned
  flightData && data.add_kist && flightData.kist_id && dispatch({
    type: 'ADD_KIST_TO_DATA',
    kist: {
      id: flightData.kist_id,
      callsign: flightData.callsign,
      registratie: flightData.registratie,
      type: flightData.type,
      category: 'prive',
      pilots: 2
    }
  })

  return flightData
}

export const saveFlightFromQueue = (data) => async (dispatch) => {
  // save flight data from queue
  if (window.navigator.onLine) {
    const flightData = await api.post('flights/save_flight.json', { ...stripPrivacyFields(data), skip_currency: true, queue: true }, data.messageOnNetworkIssue)
    // after save remove from queue
    flightData && dispatch({
      type: 'REMOVE_FROM_QUEUE',
      uuid: data.uuid
    })
    if (data?.action === 'delete' || flightData?.action == 'delete' || flightData?.is_visible === false) {
      dispatch({
        type: 'DELETE_FLIGHT',
        flightData: data
      })
      return null
    } else (
      flightData && dispatch({
        type: 'UPDATE_FLIGHT',
        flightData: { ...data, ...flightData }
      })
    )
    flightData?.delete_uuid && dispatch({
      type: 'DELETE_FLIGHT',
      flightData: { uuid: flightData.delete_uuid }
    })
    return flightData
  }
}

export const deleteFromQueue = (data) => async (dispatch) => {
  dispatch({
    type: 'REMOVE_FROM_QUEUE',
    uuid: data.uuid
  })
}

export const updateWebsocketEvent = (data, muteSound) => async (dispatch, getState) => {

  let name = data.flight?.callsign
  if (data.material) {
    name = data.material?.name?.split(":")[0]
    name = name.split(' ')[0]
  }

  !muteSound && data.message && text_to_speech(name, data.message)

  if (data.flight) {
    if (data.flight.is_deleted) {
      dispatch({
        type: 'DELETE_FLIGHT',
        flightData: data.flight
      })
    } else {
      dispatch({
        type: 'UPDATE_FLIGHT_FROM_WEBSOCKET',
        flight: data.flight
      })
    }
  }

  if (data.inspection) {
    message.success($t('Inspection voltooid voor "${name}" door ${pilot}', {name: data.material?.name, pilot: data.inspection?.name}))

    dispatch({
      type: 'UPDATE_INSPECTION',
      material: data.material,
      inspection: data.inspection
    })
  }

  data.flightlog && dispatch({
    type: 'ADD_FLIGHTLOG',
    flightlog: data.flightlog
  })
  data.ogn_mode && dispatch({
    type: 'UPDATE_OGN_MODE',
    ogn_mode: data.ogn_mode,
    default_flight_cat: data.default_flight_cat,
    default_sleep_cat: data.default_sleep_cat,
    default_tmg_cat: data.default_tmg_cat
  })

  if (data.badge_notifications?.length > 0) {
    showBadgeNotificationModal(data.badge_notifications)
  }
}

export const getFlightLogs = ({ datum }) => async (dispatch) => {
  const res = await api.post('flightlogs/get_logs.json', { datum })
  {
    res && dispatch({
      type: 'UPDATE_FLIGHTLOG',
      flightlogs: res.length > 0 ? res : []
    })
  }
}

export const saveOGNmode = ({ ogn_mode, dag_id, default_flight_cat, default_sleep_cat, default_tmg_cat }) => async (dispatch) => {
  const data = await api.post('flights/save_ogn_mode.json', { ogn_mode, dag_id, default_flight_cat, default_sleep_cat, default_tmg_cat })
  data && dispatch({
    type: 'UPDATE_OGN_MODE',
    ogn_mode: data.ogn_mode,
    default_flight_cat: data.default_flight_cat,
    default_sleep_cat: data.default_sleep_cat,
    default_tmg_cat: data.default_tmg_cat
  })
  return data
}
